export default function*() {}